import { atom } from "recoil";

import { PageHistory } from "@types";

export const historyState = atom<PageHistory[]>({
    key: "history",
    default: [],
});
